import React, {FC} from 'react';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {makeStyles} from "@mui/styles";


export interface ClosableDialogTitleBarProps  {
    onClose?: () => void
    children: React.ReactNode | React.ReactNode[]
    width?: string
}

const useStyles = makeStyles( theme => ({
    root: {
        backgroundColor: theme.palette.primary.main,
        padding: 5+"px",
        paddingLeft: 15+"px",
        lineHeight: '48px',
        height: '50px',
        position: "sticky",
        zIndex: 100,
        paddingRight: "0px",
        width: "inherit"

    },
    closeButton: {
        marginRight: 25+"px",
        color: theme.palette.common.white,
      },
}));


function ClosableDialogTitleBar({ onClose, children, width }: ClosableDialogTitleBarProps ) {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className="flex items-center justify-between">
                <div>{children}</div>
                <div>
                    { onClose
                        ? (
                            <IconButton aria-label="Close" className={ classes.closeButton }  onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        )
                        : null
                    }
                </div>

            </div>
        </div>
    );
}

export default  ClosableDialogTitleBar;